/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { RumbleRewardsDistributor } from "../RumbleRewardsDistributor";

export class RumbleRewardsDistributor__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _orbitalApes: string,
    overrides?: Overrides
  ): Promise<RumbleRewardsDistributor> {
    return super.deploy(
      _orbitalApes,
      overrides || {}
    ) as Promise<RumbleRewardsDistributor>;
  }
  getDeployTransaction(
    _orbitalApes: string,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(_orbitalApes, overrides || {});
  }
  attach(address: string): RumbleRewardsDistributor {
    return super.attach(address) as RumbleRewardsDistributor;
  }
  connect(signer: Signer): RumbleRewardsDistributor__factory {
    return super.connect(signer) as RumbleRewardsDistributor__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): RumbleRewardsDistributor {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as RumbleRewardsDistributor;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_orbitalApes",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "adder",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "rewardToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountAdded",
        type: "uint256",
      },
    ],
    name: "RewardAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "rewardToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountClaimed",
        type: "uint256",
      },
    ],
    name: "RewardClaimed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "erc20",
        type: "address",
      },
    ],
    name: "claimReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "erc20",
        type: "address",
      },
    ],
    name: "claimRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "erc20",
        type: "address",
      },
    ],
    name: "getRewardsBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "erc20",
        type: "address",
      },
    ],
    name: "getRewardsBalances",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "orbitalApes",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "rewardsClaimedByNFT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "totalRewardsPerERC20",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_orbitalApes",
        type: "address",
      },
    ],
    name: "updateOrbitalApes",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "erc20",
        type: "address",
      },
    ],
    name: "updateRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
